<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10.99 2.63c.406-.84 1.614-.84 2.02 0l2.014 4.182c.163.338.488.572.864.62l4.638.606c.933.122 1.306 1.26.624 1.9l-3.393 3.19a1.1 1.1 0 0 0-.33 1.005l.852 4.556c.171.915-.806 1.619-1.633 1.174l-4.113-2.21a1.13 1.13 0 0 0-1.066 0l-4.113 2.21c-.827.445-1.804-.259-1.633-1.174l.852-4.556a1.1 1.1 0 0 0-.33-1.005L2.85 9.938c-.683-.64-.31-1.778.623-1.9l4.64-.605c.375-.05.7-.283.863-.621z"
      stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    />
  </svg>
</template>

<script lang="ts" setup>
import type { IconProps } from '../types.js'

withDefaults(
  defineProps<IconProps>(),
  {
    size: 20,
  }
)
</script>
